import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

const SeriesOfArticlesContext = React.createContext();

const SeriesOfArticlesProvider = ({ children, value = {} }) => {
  const [nextLink, setNextLink] = useState(value?.nextLink);
  const [previousLink, setPreviousLink] = useState(value?.previousLink);

  const context = {
    nextLink,
    setNextLink,
    previousLink,
    setPreviousLink,
  };

  return (
    <SeriesOfArticlesContext.Provider value={context}>
      {children}
    </SeriesOfArticlesContext.Provider>
  );
};

SeriesOfArticlesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object,
};

const useSeriesOfArticles = () => {
  return useContext(SeriesOfArticlesContext);
};

export default useSeriesOfArticles;

export { SeriesOfArticlesProvider };
